import { Link } from 'react-router-dom';
import SiteLayout from '../../components/feature/SiteLayout';
import SectionHeading from '../../components/base/SectionHeading';
import MovieCard from '../../components/base/MovieCard';
import HeroCarousel from './components/HeroCarousel';
import GenreShortcuts from './components/GenreShortcuts';
import RankBoard from './components/RankBoard';
import IntroSection from './components/IntroSection';
import { movies } from '../../mocks/movies';

const editorPicks = movies.filter((movie) => movie.featured).slice(0, 8);

export default function Home() {
  return (
    <SiteLayout>
      <HeroCarousel />

      <GenreShortcuts />

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
        <SectionHeading
          title="编辑精选"
          subtitle="由编辑团队甄选的优质中文字幕影视作品"
          moreTo="/category/featured"
          accent
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {editorPicks.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>

      <RankBoard />

      <IntroSection />

      <section className="w-full px-4 md:px-8 pb-12 md:pb-16 bg-background-50">
        <div className="rounded-lg bg-secondary-900 px-6 py-10 md:px-12 md:py-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h2 className="font-heading font-bold text-xl md:text-3xl text-background-50 mb-2">
              想看的影片，一站找齐
            </h2>
            <p className="text-sm md:text-base text-background-300">
              输入片名、演员或类型，快速检索高清中文字幕影视资源。
            </p>
          </div>
          <Link
            to="/search"
            className="flex items-center gap-2 h-12 px-7 rounded-md bg-accent-500 hover:bg-accent-600 text-secondary-950 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
            立即搜索
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}